import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"

/** Ported from `record.css` `.keysbar` / `.keyhints`. */
export default makeStyles((theme: ModernTheme) => ({
    keysbar: {
        flex: "none",
        height: theme.modern.keysBarHeight,
        display: "flex",
        alignItems: "center",
        gap: "14px",
        padding: "0 14px",
        background: theme.modern.panel2,
        borderTop: `1px solid ${theme.modern.line}`,

        "@media (max-width:820px)": {display: "none"},
    },
    hints: {
        flex: "1 1 auto",
        minWidth: 0,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        overflowX: "auto",
        scrollbarWidth: "none",

        "&::-webkit-scrollbar": {display: "none"},
    },
    hint: {
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        font: `400 11px ${theme.modern.sans}`,
        color: theme.modern.ink3,
        whiteSpace: "nowrap",
    },
}))
